import React from 'react';


function FormInput(props) {
    //let fail = props.fail;
        const {
        type,
        id,
        className:ClasN,
        placeholder,
        value,
        name,
        handleChange,
        handleKeyDown,
        autoComplete,
        maxlength,
        pattern,
        required,
        title,
        max,min // Date
        //...props
        } = props
        //className={`input ${fail ? "input--fail" : null} `}

        const handleOnBlur = (event)=>{
            const value = event.target.value
            if (typeof value === "string"){
                event.target.value = value.trim()
            }
            handleChange(event)
        }

    return(
      <input type={type}
            id = {id}
            className = {ClasN}
            placeholder={placeholder}
            name={name}
            value={value}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            required = {required}
            autoComplete = {autoComplete}
            maxLength = {maxlength}
            pattern = {pattern}
            title = {title}
            max = {max}
            min = {min}
            onBlur ={handleOnBlur}
      />
    )
}

export default FormInput;
